module.exports = __webpack_public_path__ + "img/icon-action-report.64fa80ff.svg";